<div class="modal-header align-items-center">
  <h1 class="modal-title">{{ title }}</h1>
  <button
    *ngIf="!hasParent"
    closeModal
    type="button"
    class="btn btn-link text-dark"
    (click)="close()"
  >
    <i class="fa-solid fa-times fa-sm fa-fw"></i>
  </button>
</div>
<div class="modal-body">
  <temp-folder-structure-form
    #folderFormRef
    *ngIf="!hideFileFolder"
    [initialForm]="{ folder: initialFolder }"
  ></temp-folder-structure-form>

  <div class="d-flex align-items-center my-3">
    <span>{{ 'files.fileImportDialog.instructions' | translate }}</span>
    <div class="btn btn-primary ml-auto">
      <label for="files" class="h-100 w-100 mb-0" style="cursor: pointer">
        <i class="fa-regular fa-plus fa-fw"></i>
        {{ 'shared.terms.browse' | translate }}...
      </label>
      <input
        [accept]="accept"
        (change)="onSelect($event.target.files)"
        multiple
        hidden
        id="files"
        type="file"
      />
    </div>
  </div>
  <table *ngIf="files.length" class="table table-borderless table-sm">
    <thead>
      <tr>
        <th scope="col" [attr.colspan]="inbox ? 3 : 4" class="required">
          {{ 'shared.terms.name' | translate }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let file of files; let i = index">
        <td>
          <input
            [(ngModel)]="file.description"
            [name]="'description-' + i"
            [placeholder]="'files.placeholders.description' | translate"
            required
            class="form-control"
          />
        </td>
        <td *ngIf="!inbox" style="width: 1%">
          <div class="form-check">
            <input
              [(ngModel)]="file.isPrivate"
              [id]="'isPrivate-' + i"
              [name]="'files.model.private' | translate"
              class="form-check-input"
              type="checkbox"
            />
            <label class="form-check-label" [for]="'isPrivate-' + i">
              {{ 'files.model.private' | translate }}
            </label>
          </div>
        </td>
        <td style="width: 1%">
          <div class="form-check">
            <input
              [(ngModel)]="file.compress"
              [id]="'compress-' + i"
              [name]="'files.model.compress' | translate"
              [disabled]="!file.isPdf"
              class="form-check-input"
              type="checkbox"
            />
            <label class="form-check-label" [for]="'compress-' + i">
              {{ 'files.model.compress' | translate }}
            </label>
          </div>
        </td>
        <td style="width: 1%">
          <button
            [title]="'shared.terms.delete' | translate"
            (click)="deselectFile(file)"
            class="btn btn-outline-secondary btn-sm"
            type="button"
          >
            <i class="fa-solid fa-trash fa-fw"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <div
    *ngIf="hasLinkedObjects && isWizardEnabled && files?.length"
    class="mt-4 mb-3 text-center"
  >
    <button
      class="btn btn-primary"
      type="button"
      (click)="linkToObjectChange.emit(!linkToObject)"
    >
      {{ 'customModules.orderRegistrations.details.files.link' | translate }}
    </button>
  </div>
</div>
<div *ngIf="!hasParent || !linkToObject" class="modal-footer">
  <button
    closeModal
    type="button"
    class="btn btn-link flex-fill"
    (click)="close()"
  >
    {{ 'shared.terms.cancel' | translate }}
  </button>
  <button
    [disabled]="loading || (files && !files.length)"
    (click)="uploadFiles()"
    type="button"
    class="btn btn-success flex-fill"
  >
    {{ 'shared.terms.confirm' | translate }}
  </button>
</div>
